import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';
import ConfirmationCard from '../../components/Shared/ConfirmationCard';
import { Title, Span } from '../../components/Shared/TitleSuccess';

import { setExitingCardProps, getExitingCardProps } from '../Widget/actions';

import { formatThousands } from '../../utils/fillDynamicText';
import { ActionTypes } from '../../utils/enums';
import { copyFor } from '../../copy/copy';

const TitleComponent = props => (
    <Title>
        {props.useLocalRepresentative && !props.isSinglePerson ? (
            <Span>{copyFor('feedback', 'representatives', 'call')}</Span>
        ) : (
            <Span>
                {copyFor('feedback', 'singleRecipient', 'call', undefined, {
                    recipientName: props.recipientName
                })}
            </Span>
        )}
    </Title>
);

TitleComponent.propTypes = {
    recipientName: PropTypes.string,
    useLocalRepresentative: PropTypes.bool,
    isSinglePerson: PropTypes.bool
};

const CallAction = props => (
    <TransitionContainerNoExit>
        <ConfirmationCard
            titleComponent={
                <TitleComponent
                    recipientName={props.recipientName}
                    useLocalRepresentative={props.useLocalRepresentative}
                />
            }
            beforeAdvancing={() => {
                props.setExitingCardProps('call', props, props.exitingAction);
            }}
            {...props}
        />
    </TransitionContainerNoExit>
);

CallAction.propTypes = {
    exitingAction: PropTypes.object.isRequired,
    peopleCount: PropTypes.string.isRequired,
    recipientName: PropTypes.string.isRequired,
    useLocalRepresentative: PropTypes.bool,
    isSinglePerson: PropTypes.bool,
    setExitingCardProps: PropTypes.func.isRequired
};

export default connect(
    (state, props) => {
        const exitingProps = getExitingCardProps(
            'call',
            ['/call/success'],
            props.location.pathname,
            state
        );
        if (exitingProps) return exitingProps;

        return {
            exitingAction: state.widget.activeAction,
            recipientName: state.call.successInfo.recipientName,
            peopleCount:
                state.call.completeCall.endUsersCount !== undefined
                    ? formatThousands(state.call.completeCall.endUsersCount)
                    : '',
            useLocalRepresentative: state.call.successInfo.useLocalRepresentative,
            isSinglePerson: state.call.successInfo.isSinglePerson
        };
    },
    { setExitingCardProps },
    null,
    {
        areStatesEqual: (next, prev) => {
            if (next.widget.activeAction.type !== ActionTypes.Call) return true;

            return next === prev;
        }
    }
)(CallAction);
